import React, { useMemo, useState } from "react";
import Sidebar from "../components/Sidebar";
import Nav from "../components/Nav";
import ProjectAnalyticsTab from "../components/dashboard/ProjectAnalyticsTab";
import CompanyOverviewTab from "../components/dashboard/CompanyOverviewTab";
import Toast from "../utils/Toast";

import "../styles/Dashboard.css";

const TABS = [
  {
    id: "project",
    label: "Project Analytics",
    component: ProjectAnalyticsTab,
  },
  {
    id: "company",
    label: "Company Overview",
    component: CompanyOverviewTab,
  },
  // {
  //   id: "employee",
  //   label: "Employee Analytics",
  //   component: ComingSoon,
  // },
  // {
  //   id: "client",
  //   label: "Client Analytics",
  //   component: ComingSoon,
  // },
];

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState("project");
  const [toast, setToast] = useState({ message: "", type: "" });

  const ActiveTabComponent = useMemo(() => {
    const tab = TABS.find((item) => item.id === activeTab);
    return tab?.component || ComingSoon;
  }, [activeTab]);

  const activeLabel =
    TABS.find((item) => item.id === activeTab)?.label || "Dashboard";

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-shell">
        <Nav />
        <main className="dashboard-content">
          <Toast message={toast.message} type={toast.type} />

          <div className="dashboard-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`dashboard-tab-btn ${
                  tab.id === activeTab ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div aria-live="polite">
            <ActiveTabComponent title={activeLabel} setToast={setToast} />
          </div>
        </main>
      </div>
    </div>
  );
}

function ComingSoon({ title = "This tab" }) {
  return (
    <div className="analytics-section">
      <h3 style={{ marginTop: 0, color: "#111827" }}>{title}</h3>
      <p className="text-muted mb-0">This tab will unlock soon.</p>
    </div>
  );
}
